import React from "react"
import { HoverIconContainer } from "./styles"

const ReelerHoverIcon = ({ size, children }) => {
  return <HoverIconContainer size={size}>{children}</HoverIconContainer>
}

export default ReelerHoverIcon
